module.exports = __webpack_public_path__ + "static/media/grayEmail.e061b341.svg";